import type { NotificationEntity } from "./notification.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

const markAsRead = (id: NotificationEntity["id"]) => {
  return client.user.notifications.markAsRead(id);
};

export const useMarkNotificationAsRead = () => {
  const { mutate, ...result } = useMutation<
    ApiEmptyResponse,
    ApiError,
    NotificationEntity["id"]
  >({
    mutationFn: markAsRead,
  });

  return {
    markAsRead: mutate,
    ...result,
  };
};
